import React from 'react';
import { PlayerState } from '@push.io/shared';
import './leaderboard.css';

interface LeaderboardProps {
  players: PlayerState[];
  localPlayerId: string;
}

export function Leaderboard({ players, localPlayerId }: LeaderboardProps) {
  const sorted = [...players]
    .sort((a, b) => {
      const pa = a.placement || 999;
      const pb = b.placement || 999;
      return pa - pb;
    })
    .slice(0, 10);

  return (
    <div className="leaderboard">
      <div className="leaderboard-title">
        Ranking
      </div>
      {sorted.map((player, idx) => (
        <div
          key={player.id}
          className="leaderboard-row"
          style={{
            color: player.id === localPlayerId ? '#44ff44' : '#ccc',
          }}
        >
          <span className="leaderboard-name">
            #{idx + 1} {player.name}
          </span>
          <span className="leaderboard-state" style={{
            color: player.alive ? '#44ff44' : '#ff4444',
          }}>
            {player.alive ? 'VIVO' : 'FUERA'}
          </span>
        </div>
      ))}
    </div>
  );
}
